export default __webpack_public_path__ + "static/media/perfil.0dbff416.jpg";